
import Vue from "vue";
import {changePasswordRequest} from "@/scripts/ProfiControlRequests/AuthenticationRequests";
import {
  hasEnoughLowerCases,
  hasEnoughNumbers,
  hasEnoughSpecialSigns,
  hasEnoughUpperCases,
  hasEqualPasswords,
  hasValidMaxLength, hasValidMinLength
} from "@/scripts/Validations/PasswordValidations";
import {
  maxLength,
  minCountLowerChars,
  minCountNumbers,
  minCountSpecialSigns,
  minCountUpperChars,
  minLength
} from "@/scripts/Constants/PasswordConstraints";
import {PasswordChange} from "@/model/PasswordChange";
import {ResponseState} from "@/Enums";
import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

export default Vue.extend({
  components: {FloatingActionButton},
  props: {
    token: String,
    url: String
  },
  data: () => ({
    passwordChangeDto: new PasswordChange(),
    showCurrentPassword: false,
    showNewPassword: false,
    showNewPasswordRepeat: false,
    startViewActive: true,
    accountViewActive: false,
    showError: false,
    showSuccess: false,
    maxLength: maxLength,
    valid: true,
    responseState: ResponseState.unknown
  }),
  computed: {
    rules() {
      return {
        required: (value: string) =>
            !!value ||
            this.$t('validationError.required'),
        sameValue: (valueA: string, valueB: string) =>
            hasEqualPasswords(valueA, valueB) ||
            this.$t('validationError.passwordConfirmationInvalid'),
        max: (value: string) =>
            !value ||
            hasValidMaxLength(value) ||
            this.$t('validationError.toLong', {maxLength: maxLength}),
        min: (value: string) =>
            !value ||
            hasValidMinLength(value) ||
            this.$t('validationError.toShort', {minLength: minLength}),
        enoughNumbers: (value: string) =>
            !value ||
            hasEnoughNumbers(value) ||
            this.$t('validationError.notEnoughNumbers', {minNumberCount: minCountNumbers}),
        enoughUpperCases: (value: string) =>
            !value ||
            hasEnoughUpperCases(value) ||
            this.$t('validationError.notEnoughUpperChars', {minUpperCases: minCountUpperChars}),
        enoughLowerCases: (value: string) =>
            !value ||
            hasEnoughLowerCases(value) ||
            this.$t('validationError.notEnoughLowerChars', {minLowerCases: minCountLowerChars}),
        enoughSpecialSigns: (value: string) =>
            !value ||
            hasEnoughSpecialSigns(value) ||
            this.$t('validationError.notEnoughSpecialSigns', {minSpecialSigns: minCountSpecialSigns})
      }
    },
  },
  methods: {
    async savePassword() {
      const state = await changePasswordRequest(this.url, this.passwordChangeDto, this.token);
      this.showResponse(state);
      this.passwordChangeDto.reset();
      this.resetFormValidation();
    },
    showResponse(state: ResponseState) {
      this.showSuccess = state === ResponseState.success;
      this.showError = state === ResponseState.error;
      setTimeout(() => {
        this.showError = false;
        this.showSuccess = false;
      }, 5000)
    },
    validateForm() {
      (this.$refs.passwordForm as any).validate();
    },
    resetFormValidation() {
      (this.$refs.passwordForm as any).resetValidation();
    },
    reset() {
      this.passwordChangeDto.reset()
      this.resetFormValidation()
    }
  },
});
